import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 영업_페이지_라우터 = {
  ['bunjang-sale-management']: {
    path: '/manager/bunjang-sale-management',
    async lazy() {
      const { default: Page } = await import('@/router/manager/영업/SalesManagementPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '번개장터 상점 영업',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  ['task-extract-size']: {
    path: '/manager/task-extract-size',
    async lazy() {
      const { default: Page } = await import('@/router/manager/영업/C치수불러오기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '치수불러오기 키워드 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

export const 입점유도_라우터 = {
  ['acloset-introduction']: {
    path: '/acloset-introduction',
    async lazy() {
      const { default: Page } = await import('@/router/manager/영업/입점유도_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '세컨솔드 소개',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  ['token-parse']: {
    path: '/auth/token-parse',
    async lazy() {
      const { default: Page } = await import('@/router/manager/영업/TokenParsePage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: 'token parse',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,

  ['expired-token']: {
    path: '/auth/expired-token',
    async lazy() {
      const { default: Page } = await import('@/router/manager/영업/ExpiredTokenPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '만료된 토큰',
      displayInSidebarMenu: false,
    },
  } satisfies LookoRouteObject,
};

export const 영업_라우트_리스트: LookoRouteObject[] = Object.values(영업_페이지_라우터);
export const 입점유도_라우트_리스트: LookoRouteObject[] = Object.values(입점유도_라우터);
